/**
 * todo: probably should be an adapter?
 * todo: ability to lazy load with ajax call--update "proto.loadmore" to call out to an endpoint, passing skip/top values
 * slowly feeds an array to a ractive keypath, so long lists display right away and gradually grow...
 */
define('services/lazydom',[],function () {
    'use strict';
    var LazyDom = function (arr, keypath, ractive, onLoadMore, goto) {
        this.step = 20;
        this.index = this.step;
        this.ractive = ractive;
        this.keypath = keypath;
        this.allData = arr;
        this.len = arr.length;
        this.onLoadMore = onLoadMore;
        this.ractive.set(this.keypath, this.allData.slice(0, this.step));
        this.onLoadMore();
        this.dfd = $.Deferred();
        if (this.step > this.len) {
            //if we've already loaded all we're done
            this.dfd.resolve();
            this.destroy();
        } else {
            this.$contentPane = $('#layout-content');
            this.$window = $(window);
            this.$document = $(document);
            this.onscrollHandler = this.onscroll.bind(this);
            this.onresizeHandler = this.onresize.bind(this);
            this.$window.on('scroll', this.onscrollHandler);
            this.$window.on('resize', this.onresizeHandler);
            this.loadUntil(goto != null && goto !== 0 ? this.scrolledTo(goto) : this.viewFilled);
        }
    };
    var proto = LazyDom.prototype;

    proto.then = function(callback) {
        this.dfd.promise().then(callback);
        return this;
    };

    /**
     * if we're getting close to the end, load some more in
     */
    proto.onscroll = function () {
        if(this.$window.scrollTop() > this.$document.height() - this.$window.height() - 600) {
            this.loadMore();
        }
    };

    /**
     * Whent the window is resized, fill view
     */
    proto.onresize = function() {
        this.loadUntil(this.viewFilled);
    };

    /**
     * splice another chunk on
     */
    proto.loadMore = function (number) {
        $('.lazy-loading', this.$contentPane).remove();
        if (this.index >= this.len) {
            this.destroy(); //our work here is done
            this.dfd.resolve();
            return;
        }
        this.$contentPane.append('<div class="lazy-loading" style="text-align: center;"><img style="margin-top: 200px; height: 50px;" src="https://adestinn2blob.blob.core.windows.net/images/loading12102015-2.gif"/></div>');
        var step = number || this.step;
        var additions = this.allData.slice(this.index, this.index + step);
        additions.splice(0, 0, this.keypath, this.index, 0);
        this.ractive.splice.apply(this.ractive, additions);
        this.onLoadMore();
        this.index += step;
    };

    /**
     * loads more elements until we either have them all loaded or until a given condition is met
     * @param {Func<bool>} conditionFunc 
     */
    proto.loadUntil = function (conditionFunc) {
        this.loadInterval = setInterval(function() {
            !this.destroyed && !conditionFunc.call(this) ?
                this.loadMore(50) :
                window.clearInterval(this.loadInterval); // jshint ignore:line
        }.bind(this), 100);
    };

    /**
     * given a value, scroll to it (or as close to it as possible)
     * @param {int} scrollVal 
     * @returns {bool} 
     */
    proto.scrolledTo = function(scrollVal) {
        return function() {
            window.scrollTo(0, scrollVal);
            return this.$window.scrollTop() >= scrollVal;
        };
    };

    /**
     * when can't scroll to cause more loading (load more in, until document/scrollable height > window height--until we have the ability to scroll)
     * note we fill 2x the window height so we have some scroll space right away
     * @returns {bool}
     */
    proto.viewFilled = function () {
        var windowHeight = this.$window.outerHeight();
        return this.$document.height() - windowHeight > windowHeight;
    };

    proto.destroy = function () {
        if (this.$window != null) {
            this.$window.off('scroll', this.onscrollHandler);
            this.$window.off('resize', this.onresizeHandler);
        }
        window.clearInterval(this.loadInterval);
        if (this.$contentPane != null) {
            $('.lazy-loading', this.$contentPane).remove();
        }
        this.destroyed = true;
        this.$contentPane = null;
        this.$window = null;
        this.$document = null;
        this.onscrollHandler = null;
        this.onresizeHandler = null;
        this.step = null;
        this.index = null;
        this.ractive = null;
        this.keypath = null;
        this.allData = null;
        this.len = null;
        this.onLoadMore = null;
    };

    return LazyDom;
});

